import { apiClient } from "./apiClient";

export interface CurrentVersion {
  armVersion: string;
  frontendVersion?: string; // we don't have reliable way to get this, so leave it as optional
  backendVersion: string;
  pwshUtilsVersion?: string; // we don't have reliable way to get this, so leave it as optional
}
export interface TargetVersion extends CurrentVersion {
  frontendVersion: string;
  pwshUtilsVersion: string;
}

export interface VersionInfo {
  success: boolean;
  updateAvailable: boolean;
  updateLink: string;
  currentVersion: CurrentVersion;
  targetVersion: TargetVersion;
}

class VersionService {
  async getVersion(): Promise<VersionInfo> {
    try {
      const response = await apiClient.get<VersionInfo>("/version");
      // Handle both wrapped and direct response formats
      const versionData = response.data || response;
      return versionData;
    } catch (error) {
      console.warn("Failed to fetch version info:", error);
      // Return fallback version info
      return {
        success: false,
        updateAvailable: false,
        updateLink: undefined,
        currentVersion: undefined,
        targetVersion: undefined,
      } as any as VersionInfo;
    }
  }
}

export const versionService = new VersionService();
